import { render, staticRenderFns } from "./others.vue?vue&type=template&id=35770e92&scoped=true&"
import script from "./others.vue?vue&type=script&lang=ts&"
export * from "./others.vue?vue&type=script&lang=ts&"
import style0 from "./others.vue?vue&type=style&index=0&id=35770e92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35770e92",
  null
  
)

export default component.exports